export default {"src":"/_next/static/image/public/images/ic_success_prescription.b741933f5c2b73f96778f85a811c6536.svg","height":167,"width":126};